"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoshChatCaching = void 0;
const tslib_1 = require("tslib");
const FoshChatCaching_Types_1 = require("./FoshChatCaching.Types");
class FoshChatCaching {
    constructor(getUserMetadataDelegate) {
        this.userCaches = [];
        this.getUserMetadataDelegate = getUserMetadataDelegate;
    }
    checkCacheForUserIds(userIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const nonCachedUserIds = userIds.filter(userId => {
                return !this.userCaches.some(cachedUserId => userId === cachedUserId.userId);
            }).map(userId => {
                return {
                    userId,
                    state: FoshChatCaching_Types_1.CacheState.Uncached
                };
            });
            this.userCaches = [...nonCachedUserIds, ...this.userCaches];
            yield this.fetchUserMetadatas();
        });
    }
    fetchUserMetadatas() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.getUserMetadataDelegate == null) {
                return false;
            }
            const uncachedUsers = this.userCaches.filter(cache => cache.state === FoshChatCaching_Types_1.CacheState.Uncached);
            if (uncachedUsers.length === 0) {
                return false;
            }
            const asyncActions = [];
            const asyncActionsIds = [];
            for (let uncachedUser of uncachedUsers) {
                uncachedUser.state = FoshChatCaching_Types_1.CacheState.Caching;
                asyncActionsIds.push(uncachedUser.userId);
                asyncActions.push(this.getUserMetadataDelegate(uncachedUser.userId).catch(_ => {
                    uncachedUser.state = FoshChatCaching_Types_1.CacheState.Uncached;
                    return null;
                }));
            }
            const results = yield Promise.all(asyncActions);
            if (results.length > 0) {
                results.forEach((user, index) => {
                    const uncachedUser = uncachedUsers[index];
                    if (uncachedUser != null) {
                        if (user != null) {
                            uncachedUser.state = FoshChatCaching_Types_1.CacheState.Cached;
                            uncachedUser.metadata = user;
                        }
                        else {
                            uncachedUser.state = FoshChatCaching_Types_1.CacheState.Uncached;
                        }
                    }
                });
            }
            return true;
        });
    }
    getUserMetadataFromCache(userId) {
        var _a;
        const foundUser = this.userCaches.find(metadata => metadata.userId === userId && metadata.state === FoshChatCaching_Types_1.CacheState.Cached);
        if (!foundUser) {
            return null;
        }
        return (_a = foundUser.metadata) !== null && _a !== void 0 ? _a : null;
    }
}
exports.FoshChatCaching = FoshChatCaching;
//# sourceMappingURL=FoshChatCaching.js.map